module.exports = __webpack_public_path__ + "img/image170.24ca9497.jpg";